import(/* webpackMode: "eager" */ "/home/forge/leaderboard.greenball-events.ch/src/app/[lang]/(main)/page.tsx");
